import { render, staticRenderFns } from "./Addcase.vue?vue&type=template&id=6f9c65e5&scoped=true"
import script from "./Addcase.vue?vue&type=script&lang=js"
export * from "./Addcase.vue?vue&type=script&lang=js"
import style0 from "./Addcase.vue?vue&type=style&index=0&id=6f9c65e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c65e5",
  null
  
)

export default component.exports